import { render } from "./SubjectRegist.vue?vue&type=template&id=5d0da6d1&scoped=true"
import script from "./SubjectRegist.vue?vue&type=script&lang=js"
export * from "./SubjectRegist.vue?vue&type=script&lang=js"

import "./SubjectRegist.vue?vue&type=style&index=0&id=5d0da6d1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0da6d1"]])

export default __exports__